export default {"src":"/_next/static/media/dropDownArrowIcon.dffc04f5.svg","height":10,"width":12};